

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { lemMstApi } from '../api/lemMst.api';
import { switchMap, map } from 'rxjs/operators';
import { lemMstData, lemMst } from '../../../interfaces/lab/lemMst';

@Injectable()
export class lemMstService extends lemMstData {

  constructor(private api: lemMstApi) {
    super();
  }



  list(url: string): Observable<lemMst[]> {
    return this.api.list(url);
  }
  
  get(url: string): Observable<any> {
    return this.api.get(url);
  }

  getById(url:string): Observable<lemMst>{
      return this.api.getById(url);
  }

  create(url: string, data:lemMst): Observable<lemMst> {
    return this.api.add(url,data);
  }
  createby(url: string, data): Observable<any> {
    return this.api.addby(url,data);
  }

  update(url: string, data:lemMst): Observable<lemMst> {
    return this.api.update(url,data);
  }
  updateby(url: string, data): Observable<any> {
    return this.api.updateby(url,data);
  }
  put(url: string, data:lemMst): Observable<lemMst> {
    return this.api.put(url,data);
  }
 

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
